import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { FlowReport, ReportRange } from '@eombor/contracts';
import type { ApiClientError } from '../../../shared/api/client.js';
import { flowApi, type FlowNode, type FlowView } from '../api/flow.api.js';

/**
 * Statistika so'rovi.
 *
 * Kalitga daraja ham, ota tugun ham, davr ham kiradi: tuzilma bo'ylab
 * yurganda har qadam KESHDA qoladi va orqaga qaytish so'rovsiz bo'ladi.
 * Rahbar aynan shunday ishlaydi — pastga tushib, qaytib, qo'shnisiga
 * kirib solishtiradi.
 */
export const flowKeys = {
  all: ['report', 'flow'] as const,
  node: (range: ReportRange, node: FlowNode | null, view: FlowView) =>
    [
      'report',
      'flow',
      /* `auto` — serverning o'zi tanlagan daraja. Kalitda alohida qiymat,
         chunki u boshqa so'rov: javobda daraja ham o'zgarishi mumkin. */
      node?.level ?? 'auto',
      node?.parentId ?? '',
      range.from,
      range.to,
      view.q,
      view.sort,
      view.page,
    ] as const,
};

/** Kunlik agregat — bir daqiqada o'zgarmaydi, so'rov esa qimmat. */
const STALE_MS = 5 * 60_000;

export const useFlowReport = (
  range: ReportRange,
  node: FlowNode | null,
  view: FlowView,
): UseQueryResult<FlowReport, ApiClientError> =>
  useQuery<FlowReport, ApiClientError>({
    queryKey: flowKeys.node(range, node, view),
    queryFn: () => flowApi.report(range, node, view),
    staleTime: STALE_MS,
    /*
     * Oldingi daraja EKRANDA qoladi.
     *
     * Satr bosilganda jadval skeletonga aylansa, ko'z yo'qotadi: odam
     * qaysi satrni bosganini va qayerga tushganini unutadi. Eski satrlar
     * bir lahza turib, keyin yangisiga almashadi.
     *
     * Qidiruvda bu ayniqsa muhim: har harfda ro'yxat skeletonga
     * aylansa, yozib bo'lgunicha ekran miltillab turadi.
     */
    placeholderData: (previous) => previous,
  });
